import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { QrCode } from "lucide-react";

export default function ScannerQrButton() {
  const [open, setOpen] = useState(false);
  const url = `${window.location.origin}/scanner`;

  return (
    <>
      <button data-testid="open-scanner-qr" onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 text-sm font-medium px-3 py-2 rounded-lg">
        <QrCode size={16} /> Scanner de credenciales
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white sm:max-w-[380px] p-6">
          <DialogHeader>
            <DialogTitle className="font-display text-base text-center">Lector de credenciales en el móvil</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">
            <p className="text-xs text-slate-500 leading-snug text-center">Escanea este QR con la cámara del smartphone. Al abrir el link, inicia sesión y empieza a escanear credenciales PDF417 o QR.</p>
            <div className="flex justify-center py-2">
              <div className="p-3 bg-white border border-slate-200 rounded-lg">
                <QRCodeSVG value={url} size={220} level="M" />
              </div>
            </div>
            <p className="text-[11px] text-slate-400 text-center pt-1">Al escanear, el trabajador queda marcado con <b>Credencial entregada</b>.</p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
